export enum MyProfileTabs {
    Profile,
    Notifications,
}